function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M305 698 c-134 -67 -165 -91 -165 -125 0 -28 41 -73 68 -73 10 0 60 20 111 45 51 25 96 45 101 45 4 0 17 -15 28 -34 l21 -35 -159 -96 c-175 -106 -167 -104 -250 -49 -30 20 -44 24 -52 16 -17 -17 11 -43 77 -75 139 -69 283 -73 473 -13 157 50 228 46 368 -18 38 -17 61 -23 67 -17 7 7 6 15 -2 24 -26 32 -191 87 -258 87 -28 0 -33 4 -33 23 0 27 -169 301 -206 335 -14 12 -35 22 -47 21 -12 0 -76 -27 -142 -61z m256 -125 c51 -82 94 -159 94 -172 0 -22 -10 -27 -110 -58 -118 -37 -245 -52 -304 -36 l-34 9 136 82 c197 120 185 104 137 180 -22 34 -42 62 -45 62 -3 0 -55 -23 -115 -51 -110 -52 -140 -56 -140 -19 0 15 27 34 128 84 70 36 134 65 143 65 10 1 51 -54 110 -146z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M738 624 c-30 -16 -58 -61 -58 -94 0 -34 28 -78 60 -95 16 -8 38 -15 50 -15 53 0 110 57 110 110 0 34 -28 78 -60 95 -36 19 -67 19 -102 -1z m99 -46 c29 -27 29 -65 1 -95 -27 -29 -65 -29 -95 -1 -29 27 -29 65 -1 95 27 29 65 29 95 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M920 461 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"
}));

function SvgOtherLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherLogo);
export default __webpack_public_path__ + "static/media/otherLogo.8f8eaf434d31d77c8f5faa21a7a9c8b8.svg";
export { ForwardRef as ReactComponent };